<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      OT Schedule: Cancel List
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="3">
        <template>
          <v-autocomplete
            :items="doctors"
            color="white"
            item-text="dr_name"
            item-key="id"
            item-value="id"
            label="Doctor List"
            v-on:change="getReports()"
            v-model="doctor_id"
            :loading="isLoading"
            outlined
            dense
            hide-details
          ></v-autocomplete>
        </template>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Select Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              dense
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            @click:date="dateSelect"
            type="month"
            v-on:change="getReports()"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <template>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
            dense
          ></v-text-field>
        </template>
      </v-col>
      <v-col cols="12" sm="6" md="1">
        <template>
          <v-row align="center" justify="space-around">
            <v-btn depressed color="primary" append-icon="mdi-printer" @click="printList"
              >Print
            </v-btn>
          </v-row>
        </template>
      </v-col>
      <v-col cols="12" sm="6" md="1">
        <template>
          <v-row align="center" justify="space-around">
            <v-btn depressed color="primary" append-icon="mdi-printer" @click="createNew"
              >Add New
            </v-btn>
          </v-row>
        </template>
      </v-col>
    </v-card-title>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"
        dense
        disable-pagination
        :hide-default-footer="true"
        :loading="loadingstatus"
        loading-text="Loading... Please wait"
      >




        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="ot_cancel_details(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="green"
                label
                outlined
                small
                ><v-icon small> mdi-mortar-pestle-plus </v-icon>
              </v-chip>
            </template>
            <span>Details </span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getReports">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" persistent width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              OT Schedule Cancel
            </v-card-title>
            <v-card-text v-if="cancelData">
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>Patient ID</td>
                      <td>:</td>
                      <td class="">{{ cancelData.patient_id }}</td>
                    </tr>
                    <tr>
                      <td>Patient Name</td>
                      <td>:</td>
                      <td class="">{{ cancelData.patient.patient_name }}</td>
                    </tr>
                    <tr>
                      <td>OT Time</td>
                      <td>:</td>
                      <td class="">{{ cancelData.starting_time }}</td>
                    </tr>
                    <tr>
                      <td>OT Amount</td>
                      <td>:</td>
                      <td class="">{{ cancelData.amount }}</td>
                    </tr>
                    <tr>
                      <td>Cancel Note</td>
                      <td>:</td>
                      <td class="">{{ cancelData.cancel_note }}</td>
                    </tr>
                    <tr>
                      <td>Cancel time</td>
                      <td>:</td>
                      <td class="">{{ cancelData.cancel_time }}</td>
                    </tr>
                    <tr>
                      <td>Counselor</td>
                      <td>:</td>
                      <td class="" v-if="cancelData.counselor">{{ cancelData.counselor.full_name }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" text @click="dialog = false"> Close </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      cancelData: null,
      dialog: false,
      search: "",
      date: new Date().toISOString().substr(0, 7),
      nowDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      doctor_id: 0,
      doctors: [],
      loadingstatus: true,
      isLoading: true,
      headers: [
        {
          text: "Patient ID",
          value: "patient_id",
        },
        { text: "Patient Name", value: "patient.patient_name" },
        { text: "Doctor", value: "doctor.dr_name" },
        {
          text: "Operation Name",
          sortable: true,
          value: "operation_subhead",
        },
        // { text: "Time", sortable: true, value: "starting_time" },
        // { text: "OT Amount", value: "amount" },
        // { text: "Due Amount", value: "due_amount" },
        // { text: "Counselor", value: "counselor.first_name" },
        { text: "Status", value: "status" },
        { text: "Created by", value: "user.last_name" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Operations",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.getReports();
    this.getDoctors();
    // console.log(this.$store.getters.getUserName);
    // console.log(atshq.defaults.headers.common.api_URL);
  },
  methods: {
    getReports() {
      atshq
        .get(
          "ot-module/schedule-cancel-list?date=" +
            this.date +
            "&doctor_id=" +
            this.doctor_id
        )
        .then((response) => {
          this.desserts = response.data.data;
          this.loadingstatus = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getDoctors() {
      atshq
        .get("doctors")
        .then((response) => {
          this.doctors = response.data.data;
          this.loadingstatus = false;
          this.isLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    b_number_format(n) {
      // return n != null
      //   ? n.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
      //   : 0;
      return n;
    },
    getColor(status) {
      if (status == "active") return "orange";
      else if (status == "Registration") return "green";
      else if (status == "cancel") return "red";
    },
    createNew() {
      window.location.href = "/ot-module/schedule-create";
    },
    printList() {
      window.open(
        this.returnUrl +
          "printdoc/otSchedule/" +
          this.date +
          "/" +
          this.date +
          "/" +
          this.doctor_id
      );
    },
    dateSelect() {
      this.loadingstatus = true;
      this.getReports();
    },
    ot_details(item) {
      window.location.href = "/ot-registration/" + item.registration_no;
    },

    ot_cancel_details(item) {
      this.cancelData = item;
      this.dialog = true;
    },
  },
};
</script>
